/** A campaign's task-tracking totals: every task, and those still in progress. */
export type TaskCounts = { sumTotal: number; taskProcessing: number };

/**
 * Whether the campaign's tasks have just settled: nothing in progress, and different counts from the last poll seen
 * (a task finished, or new ones finished between polls) (#6826).
 *
 * The first counts seen are only a baseline: tasks that settled before the page opened are already in the campaign
 * the page loaded, so settling is announced only when it happens while the page is open.
 */
export function didTasksSettle(previous: TaskCounts | null, current: TaskCounts): boolean {
  if (previous === null || current.sumTotal === 0 || current.taskProcessing > 0) {
    return false;
  }
  return previous.taskProcessing !== current.taskProcessing || previous.sumTotal !== current.sumTotal;
}
